var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tenancy-record dashboard" }, [
    _vm.loading
      ? _c("h6", { staticClass: "font-dark-gray" }, [
          _c("i", { staticClass: "rotation fa fa-refresh" }),
          _vm._v("\n    " + _vm._s(_vm.$t("loading")) + "\n  "),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.tenancyRecords && _vm.tenancyRecords.length > 0,
            expression: "tenancyRecords && tenancyRecords.length > 0",
          },
        ],
      },
      [
        _c("div", { staticClass: "dashboard__title" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("company.titles.tenancyRecord")) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "dashboard__table" }, [
          _c("table", { staticClass: "sort_table" }, [
            _c("thead", [
              _c(
                "tr",
                { staticClass: "dashboard__table--header" },
                _vm._l(_vm.tableHeaders, function (header) {
                  return _c(
                    "th",
                    {
                      key: header.name,
                      class: header.className,
                      on: {
                        click: function ($event) {
                          return _vm.sortBy(header.attr)
                        },
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "\n                " +
                            _vm._s(header.name) +
                            "\n                "
                        ),
                        _vm.sortingAttr === header.attr
                          ? _c("i", {
                              class: [
                                _vm.reverse ? "triangle-down" : "triangle-up",
                              ],
                            })
                          : _vm._e(),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.sortedRecords, function (item) {
                return _c(
                  "tr",
                  { key: item.id, staticClass: "dashboard__table--body" },
                  [
                    _c("td", [
                      _c(
                        "a",
                        {
                          staticClass: "link_text",
                          on: {
                            click: function ($event) {
                              return _vm.navToPage(item)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(item.companyName || _vm.emptyValue) +
                              "\n              "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(item.tradeName || _vm.emptyValue)),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(_vm.translateTenancyType(item.type))),
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(item.building || _vm.emptyValue))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(item.floor || _vm.emptyValue))]),
                  ]
                )
              }),
              0
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }